import UI from '/javascripts/utils/UI';

UI(
  {
    component: '.Publications',
    grid: '.Publications-items',
    listView: '.Publications-ListView',
    gridView: '.Publications-GridView'
  },
  ({ grid, listView, gridView }) => {
    setPublicationsView();

    function setPublicationsView() {
      listView.addEventListener('click', function() {
        let items = document.querySelectorAll('.PublicationsItem');

        grid.classList.add('Publications-items--list');
        grid.classList.remove('Publications-items--grid');

        listView.classList.add('PublicationsFilter-view--active');
        gridView.classList.remove('PublicationsFilter-view--active');

        items.forEach((item) => {
          item.classList.add('PublicationsItem--list');
          item.classList.remove('PublicationsItem--grid');
        });
      });

      gridView.addEventListener('click', function() {
        let items = document.querySelectorAll('.PublicationsItem');

        grid.classList.add('Publications-items--grid');
        grid.classList.remove('Publications-items--list');

        listView.classList.remove('PublicationsFilter-view--active');
        gridView.classList.add('PublicationsFilter-view--active');

        items.forEach((item) => {
          item.classList.add('PublicationsItem--grid');
          item.classList.remove('PublicationsItem--list');
        });
      });

      window.addEventListener('resize', function() {
        if (window.innerWidth <= 1024 && grid.classList.contains('Publications-items--list')) {
          let items = document.querySelectorAll('.PublicationsItem');

          grid.classList.add('Publications-items--grid');
          grid.classList.remove('Publications-items--list');

          listView.classList.remove('PublicationsFilter-view--active');
          gridView.classList.add('PublicationsFilter-view--active');

          items.forEach((item) => {
            item.classList.add('PublicationsItem--grid');
            item.classList.remove('PublicationsItem--list');
          });
        }
      });
    }
  }
);
